export const handleWhatsappMessage = () => {
    const phoneNumber = "5512997847924";
    const message = "Olá, sou usuário do Simulie e preciso de ajuda.";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappURL, "_blank");
  };